<div class="center-header-info">
  <div class="location-column">
    <h3>Global</h3>
    @if (selectedLocation) {
      <h4>{{ selectedLocation?.name | titlecase }}</h4>
    }
  </div>
  @if (selectedLocation) {
    <div class="search-column">
      <emm-menu-search
        (clearSearchButtonClicked)="handleClearSearchButtonClicked()"
        (searchButtonClicked)="handleSearchButtonClicked($event)"
      ></emm-menu-search>
    </div>
  }
  <div class="button-column">
    <aside class="row">
      <button
        [attr.data-testid]="'add_button'"
        mat-icon-button
        matTooltip="Add Global Submenu"
        (click)="add.emit()"
        >
        <mat-icon class="mat-class">add</mat-icon>
      </button>
      @if (!(isSearchMode$ | async)) {
        <button
          [attr.data-testid]="'sort_button'"
          mat-icon-button
          matTooltip="Sort Submenus"
          (click)="openMenu($event)"
          >
          <mat-icon class="mat-class" [matMenuTriggerFor]="sortMenu">sort</mat-icon>
        </button>
      }
      <mat-menu class="sort-menu" #sortMenu="matMenu">
        @if (!(isSearchMode$ | async)) {
          <ng-template matMenuContent>
            <button mat-menu-item (click)="sortByName.emit()">Sort By Name</button>
            <button mat-menu-item (click)="sortByTag.emit()">Sort By Tag</button>
          </ng-template>
        }
      </mat-menu>
    </aside>
  </div>
</div>
